import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from './SafeIcon';

const Button = ({ children, to, onClick, variant = 'primary', icon, className = '', disabled = false, ariaLabel, ...props }) => {
  const baseStyles = "inline-flex items-center justify-center font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";
  
  const variants = {
    primary: "bg-slate-900 text-white hover:bg-slate-800 hover:scale-105 active:scale-95 shadow-lg shadow-slate-900/20 px-8 py-4 text-base focus:ring-slate-900",
    secondary: "bg-white text-slate-900 border border-slate-200 hover:border-slate-300 hover:bg-slate-50 px-8 py-4 text-base focus:ring-slate-300",
    outline: "bg-transparent border border-current hover:bg-white/10 px-8 py-4 text-base focus:ring-white/30",
    ghost: "bg-transparent hover:bg-slate-100 text-slate-700 hover:text-slate-900 px-4 py-2 text-sm focus:ring-slate-300",
    white: "bg-white text-slate-900 hover:bg-slate-50 hover:scale-105 shadow-xl px-8 py-4 text-base font-bold focus:ring-slate-300"
  };

  const combinedClassName = `${baseStyles} ${variants[variant] || variants.primary} ${className}`;

  const content = (
    <>
      {children}
      {icon && (
        <SafeIcon
          icon={icon}
          className={`ml-2 w-5 h-5 transition-transform group-hover:translate-x-1`}
          aria-hidden="true"
        />
      )}
    </>
  );

  if (to) {
    return (
      <Link
        to={to}
        className={`${combinedClassName} group`}
        aria-label={ariaLabel || (typeof children === 'string' ? children : undefined)}
        {...props}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`${combinedClassName} group`}
      disabled={disabled}
      aria-label={ariaLabel || (typeof children === 'string' ? children : undefined)}
      {...props}
    >
      {content}
    </button>
  );
};

export default Button;